<!--
    Summary:
        firstchoice.exhibition.web - index
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-index" title="index" :class="[isEng ? 'en' : '']">
    <banner>
      <img src="../../../assets/images/mthfr/Header_1920x380_mthfr.jpg"/>
      <div slot="title">{{$t('Mthfr.Title')}}</div>
    </banner>
    <mthfr-p1></mthfr-p1>
    <mthfr-p2></mthfr-p2>
    <mthfr-p3></mthfr-p3>
    <mthfr-p4></mthfr-p4>
    <mthfr-p5></mthfr-p5>
    <mthfr-p6></mthfr-p6>
    <mthfr-p7></mthfr-p7>
    <mthfr-p8></mthfr-p8>
    <mthfr-p9></mthfr-p9>
    <mthfr-p10></mthfr-p10>
    <mthfr-p11></mthfr-p11>
    <mthfr-p12></mthfr-p12>
    <mthfr-p13></mthfr-p13>
  </div>
</template>

<script>
  import Banner from "../../../components/banner";
  import MthfrP2 from "./mthfr-p2";
  import MthfrP3 from "./mthfr-p3";
  import MthfrP4 from "./mthfr-p4";
  import MthfrP5 from "./mthfr-p5";
  import MthfrP6 from "./mthfr-p6";
  import MthfrP7 from "./mthfr-p7";
  import MthfrP8 from "./mthfr-p8";
  import MthfrP9 from "./mthfr-p9";
  import MthfrP10 from "./mthfr-p10";
  import MthfrP11 from "./mthfr-p11";
  import MthfrP12 from "./mthfr-p12";
  import MthfrP13 from "./mthfr-p13";
  import MthfrP1 from "./mthfr-p1";

  export default {
    name: "index",
    components: {MthfrP1, MthfrP13, MthfrP12, MthfrP11, MthfrP10, MthfrP9, MthfrP8, MthfrP7, MthfrP6, MthfrP5, MthfrP4, MthfrP3, MthfrP2, Banner},
    computed:{
      isEng(){
        console.log('this.$store.state.lang',this.$store.state.lang)
        console.log('this.$i18n.locale',this.$i18n.locale)

        return this.$i18n.locale==='en-US';
      }
    },
  }
</script>

<style lang="scss">
  .v-mthfr-index {
    text-align: left;

    .p1 {
      background-color: #e699b2;
      padding-top: 30px;
      padding-bottom: 30px;
      text-justify: auto;
    }

    .card {
      padding-bottom: 30px;
    }


    .box-wrapper {
      display: flex;

      & > div {
        width: 16.67%;
      }
    }

  }
</style>

<style lang="scss">
  .table-wrapper {
    text-align: center;
    line-height: 27px;
    letter-spacing: 1px;
    color: #3b3b3b;
    font-weight: 400;
    font-size: 16px;

    table#cu-table {
      padding-left: 5px !important;
    }

    table th {
      border: 0;
      padding: 5px 7px;
    }

    #cu-table caption {
      font-size: 2.532rem;
    }

    #cu-table {
      font-family: Microsoft\ JhengHei, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    #cu-table th {
      padding: 1.2307em 1.2307em 1em;
    }

    #cu-table th {
      padding-top: 12px;
      padding-bottom: 12px;
      font-family: Microsoft\ JhengHei, sans-serif;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      background-color: #efae9e;
      color: #fff;
    }

    #cu-table td {
      padding: .75em 1em .602em;
    }

    #cu-table tr:nth-child(even) {
      background-color: rgba(251, 207, 192, .2);
    }
  }
  .leftmargin{
    text-align: left;
    padding-left:100px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/genedetection/mthfr/index.vue